/**
 * Tab feature gating helpers for POS and settings consumers.
 */

export function isHouseTabsFeatureActive (businessInfo) {
  if (businessInfo?.house_tabs_feature_active !== undefined && businessInfo?.house_tabs_feature_active !== null) {
    return !!businessInfo.house_tabs_feature_active
  }
  if (businessInfo?.house_tabs_enabled !== undefined && businessInfo?.house_tabs_enabled !== null) {
    return !!businessInfo.house_tabs_enabled
  }
  return !!businessInfo?.tabs_enabled
}

export function isBarTabsFeatureActive (businessInfo) {
  if (businessInfo?.bar_tabs_feature_active !== undefined && businessInfo?.bar_tabs_feature_active !== null) {
    return !!businessInfo.bar_tabs_feature_active
  }
  if (businessInfo?.bar_tabs_enabled !== undefined && businessInfo?.bar_tabs_enabled !== null) {
    return !!businessInfo.bar_tabs_enabled
  }
  return !!businessInfo?.tabs_enabled
}

export function isAnyTabsFeatureActive (businessInfo) {
  if (businessInfo?.tabs_feature_active !== undefined && businessInfo?.tabs_feature_active !== null) {
    return !!businessInfo.tabs_feature_active
  }
  return isHouseTabsFeatureActive(businessInfo) || isBarTabsFeatureActive(businessInfo)
}

export function isBarTabRegisterAvailable (businessInfo) {
  return isBarTabsFeatureActive(businessInfo) && businessInfo?.bar_tab_available !== false
}
